module.exports = __webpack_public_path__ + "static/assets/7838388419a0268456642d4a08fcf5b9.gif";